import React, { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { getSession, valdiatePage, BaseUrl, ApiKey } from '../../global';
import { getSubAaccounts, saveSubAccount } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import axios from 'axios';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';

export const qsrWeightColumns = [
  { label: "Booking Date", key: "bookingDate" },
  { label: "Arrival Date", key: "arivalDate" },
  { label: "Customer Location Name", key: "locationName" },
  { label: "Origin Branch", key: "originBracnh" },
  { label: "Consignment Number", key: "CN" },
  { label: "Booking Weight", key: "BookingWeight" },
  { label: "Arrival Weight", key: "OpsWeight" },
  { label: "Weight Difference", key: "weightDifference" },
];


const WeightDiscrepency = () => {
    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);
    const history = useHistory();

    const d = {
        accountNo: accounts[0],
        from: new Date().toISOString().slice(0, 10),
        to: new Date().toISOString().slice(0, 10)
    };

    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);

     
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        locationName: '',
        CN: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'bookingDate', name: 'Booking Date', searchBox: false, visible: true},
        {key: 'arivalDate', name: 'Arrival Date', searchBox: false, visible: true},
        {key: 'locationName', name: 'Customer Location Name', searchBox: true, visible: true},
        {key: 'originBracnh', name: 'Origin Branch', searchBox: false, visible: true},
        {key: 'CN', name: 'Consignment Number', searchBox: true, visible: true},
        {key: 'BookingWeight', name: 'Booking Weight', searchBox: false, visible: true},
        {key: 'OpsWeight', name: 'Arrival Weight', searchBox: false, visible: true},
        {key: 'weightDifference', name: 'Weight Difference', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (valdiatePage('/weightdiscrepency')) {

        } else {
            history.push('/login');
        }
        return () => {

        }
    }, []);


    const getReport = async (d) => {
        try {
            const rs = await axios.post(BaseUrl + 'api/Reports/WeightDiscrepency', d, {
                headers: {
                    key: ApiKey,
                }
            });
            return rs.data;
        } catch (e) {
            return { ok: false, msg: e }
        }
    }

    const onSubmit = async () => {
        if (Date.parse(data.from) <= Date.parse(data.to)) {
            dispatch(setLoading({ data: true }));
            const rs = await getReport(data);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            } else {
                alert(rs.msg);
                setGrid([]);
            }
        } else {
            alert('Invalid Date');
            setGrid([]);
        }
    }

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    function diff(num1, num2) {
        if (num1 > num2) {
            return Math.abs(num1 - num2);
        } else {
            return Math.abs(num2 - num1);
        }
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Weight Discrepency</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className='row'>
                <div className='col-lg col-sm'>
                    <label>Account</label>
                    <select className='form-select' value={data.accountNo} onChange={e => updateData('accountNo', e.target.value)}>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className='col-lg col-sm'>
                    <label>From</label>
                    <input type='date' className='form-control' value={data.from} onChange={e => updateData('from', e.target.value)} />
                </div>
                <div className='col-lg col-sm'>
                    <label>To</label>
                    <input type='date' className='form-control' value={data.to} onChange={e => updateData('to', e.target.value)} />
                </div>
                <div className='col-lg col-sm'>
                    <button type='button' className='btn btn-primary' style={{ marginTop: 22 }} onClick={onSubmit}>Submit</button>
                </div>
            </div>
            {
                originalGrid.length > 0 &&
                <div className='row mt-2 pb-2'>
                    <div className='col-12'>
                        <div style={{ textAlign: 'right' }}>
                            {/* <ExportExcelButton data={originalGrid} columns={qsrOnicColumns} fileName="QSR-Onic_Report"/> */}

                            <ExportExcelButton data={originalGrid.map(e => ({
                                bookingDate: e?.bookingDate && new Intl.DateTimeFormat("en-GB", {
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit"
                                }).format(new Date(e?.bookingDate)),
                                arivalDate: e?.arivalDate && new Intl.DateTimeFormat("en-GB", {
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit"
                                }).format(new Date(e?.arivalDate)),
                                locationName: e?.locationName,
                                originBracnh: e?.originBracnh,
                                CN: e?.CN,
                                BookingWeight: e?.BookingWeight,
                                OpsWeight: e?.OpsWeight,
                                weightDifference: e?.BookingWeight ? diff(e?.BookingWeight, e?.OpsWeight) : 0
                            }))}
                            columns={qsrWeightColumns} fileName="QSRWeight_Report" />
                        </div>
                        <br />

                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <tr key={index}>
                                        <td>{(index + 1)+(page*pageLimit)}</td>
                                        <td>
                                            {x?.bookingDate && new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit"
                                            }).format(new Date(x?.bookingDate))}</td>
                                        <td>
                                            {x.arivalDate && new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit"
                                            }).format(new Date(x?.arivalDate))}</td>
                                        <td style={{ minWidth: 200 }}>
                                            <SeeMoreModal detail={x.locationName} maxLength={80} />
                                        </td>
                                        <td>{x?.originBracnh}</td>
                                        <td>{x?.CN}</td>
                                        <td>{x?.BookingWeight}</td>
                                        <td>{x?.OpsWeight}</td>
                                        <td>{x?.BookingWeight ? diff(x?.BookingWeight, x?.OpsWeight) : 0}</td>
                                    </tr>
                                )
                            }
                        />
                    </div>
                </div>
            }
        </div>
    </section>
}

export default WeightDiscrepency;